import React, { memo, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../../helper/Countdown';
import usePageContent from '../../hooks/usePageContent';
import RecommendedProductList from './RecommendedProductsList';
import Nav from 'react-bootstrap/Nav';
import useProductList from '../../hooks/useProductList';
import { useAppConfig } from '../../context/AppConfigContext';
import useProductCategoryByStore from '../../hooks/useProductCategoryByStore';

const SampleNextArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
});

const SamplePrevArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
});

const RecommendedProducts = ({ store, storeId, productCategory }) => {
    const { lang } = useParams();
    const { config } = useAppConfig();
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const { fetchPageContent, data, status, error, resetStatus } = usePageContent();
    const [dataPromo, setDataPromo] = React.useState([]);

    const currency = config?.currency === 'USD' ? '$' : config?.currency === 'AUD' ? 'AU$' : 'Rp';

    useEffect(() => {
        if (status === 'idle') {
            fetchPageContent({ type: 'home', field: 'HotDealsToday', language: 'en-US' });
        }

        if (status === 'done') {
            //console.log(data);
            setDataPromo(data === '' ? [] : JSON.parse(data));
        }
        // console.log(data);
        // console.log(status);
    }, [status]);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setTimeLeft(getCountdown());
    //     }, 1000);

    //     return () => clearInterval(interval);
    // }, []);

    //nav pindah kesini

    const [filterCategoryId, setFilterCategoryId] = useState(undefined);
    const [page, setPage] = useState(0);

    // const {
    //     fetchProductCategoryByStore,
    //     data: productCategory,
    //     status: productCategoryStatus,
    //     error: productCategoryError
    // } = useProductCategoryByStore();

    const {
        fetchProductList,
        data: productList,
        total: productListTotal,
        status: productListStatus,
        error: productListError
    } = useProductList();

    // useEffect(() => {
    //     if (store && store.userId) {
    //         fetchProductCategoryByStore(store.userId);
    //     }
    // }, [store]);

    const setSelectedGallery = (id) => {
        setFilterCategoryId(id);
        setPage(0);
    };

    const setAllCategory = () => {
        setFilterCategoryId(undefined);
        setPage(0);
    };

    useEffect(() => {
        if (!storeId) return
        // console.log("check fetching categoryid", filterCategoryId);
        fetchProductList({
            // categoryIds: keyword ?? filterCategoryId,
            categoryIds: filterCategoryId,
            companyId:storeId,
            // sortBy: sortBy.split("-")[0],
            // sortType: sortBy.split("-")[1],
            skip: 0,
            take: 20
        });
    }, [filterCategoryId, page, storeId]);

    useEffect(() => {
        //console.log(productListStatus);
        if (productListStatus === 'done') {
            // setIsLastPage(page + 1 === Math.ceil(productListTotal / 20));
            // setIsFirstPage(page === 0);
        }
    }, [productListStatus]);

    // console.log("productList data displayed" , productList)

    //nav function

    const itemCount = productList?.length ?? 0;
    const safeSlidesToShow = Math.min(4, itemCount || 1);

    const settings = {
        dots: false,
        arrows: itemCount > 1,
        infinite: false,
        speed: 600,
        slidesToShow: safeSlidesToShow,
        slidesToScroll: 1,
        autoplay: itemCount > safeSlidesToShow,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: Math.min(3, itemCount || 1)
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: Math.min(2, itemCount || 1)
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    return (
        <>
            <section className="categoryNav">
                <div className="container">
                    {/* <Nav className="justify-content-start" activeKey={"All"}>


                        <Nav.Item >
                            <Nav.Link eventKey={"All"} onClick={() => setAllCategory()}>
                                All Products
                            </Nav.Link>
                        </Nav.Item>

                        {Array.isArray(productCategory) &&
                            productCategory.length > 0 &&
                            productCategory.slice(0, 5).map((item, index) => (
                                <Nav.Item key={item.id} className={filterCategoryId === item.id ? "active": ""}>
                                    <Nav.Link eventKey={"category_1"} onClick={() => setSelectedGallery(item.id)}>
                                        {item.name}
                                    </Nav.Link>
                                </Nav.Item>

                            ))}

                            <Nav.Item >
                                <Nav.Link to="/product" eventKey={"Other"}>
                                    Other
                                </Nav.Link>
                            </Nav.Item>
                    </Nav> */}
                    <div
                        className="d-flex justify-content-start"
                        style={{
                            borderBottom: '1px solid #e6e6e6',
                            color: 'gray',
                            fontFamily: 'Quicksand',
                            fontSize: '14px',
                            fontWeight: '600'
                        }}
                    >
                        <Link
                            to="#"
                            style={{
                                padding: '0.5rem 1rem',
                                color: filterCategoryId ? '#828282' : '#970a02',
                                borderBottom: filterCategoryId ? '0' : '2px solid #970a02'
                            }}
                            onClick={(e) => {
                                e.preventDefault();
                                setAllCategory();
                            }}
                        >
                            All Products
                        </Link>
                        {Array.isArray(productCategory) &&
                            productCategory.length > 0 &&
                            productCategory.slice(0, 9).map((item, index) => (
                                <Link
                                    to={'#'}
                                    key={item.id}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setSelectedGallery(item.id);
                                    }}
                                    style={{
                                        padding: '0.5rem 1rem',
                                        color: filterCategoryId !== item.id ? '#828282' : '#970a02',
                                        borderBottom: filterCategoryId !== item.id ? '0' : '2px solid #970a02'
                                    }}
                                >
                                    {item.name}
                                </Link>
                            ))}
                        <Link to={'/products'} style={{ padding: '0.5rem 1rem', color: '#828282' }} className={''}>
                            Others
                        </Link>
                    </div>
                </div>
            </section>

            <section className="newarrivalproducts py-80">
                <div className="container container-md">
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">You Might Like</h5>
                            <div className="flex-align mr-point gap-16">
                                <Link
                                    to="/products"
                                    className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                                >
                                    View All
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row g-12">
                        <div className="col-md-12">
                            <RecommendedProductList product={productList} />
                            {/* {Array.isArray(productList) &&
                                productList.length > 0 & (
                                    <Slider {...settings}>
                                        {
                                            productList.map((item, index) => (

                                                <div key={index} className='pb-1' style={{ minHeight: "100%" }}>
                                                    <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-one-600 rounded-16 position-relative transition-2" style={{ width: "100%", maxWidth: "256px" }}>
                                                        <div className='w-100'>
                                                            {item?.discountPrice > 0 &&
                                                                item?.discountPrice < item?.price && (
                                                                    <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white">
                                                                        Sale{" "}
                                                                        {Number(item?.discount)
                                                                            ?.toFixed(0)
                                                                            ?.toLocaleString("en-US")}
                                                                        %
                                                                    </span>
                                                                )}
                                                            <Link
                                                                to={`/product-details/${encodeURIComponent(item?.slug)}`}
                                                                className="product-card__thumb flex-center"
                                                            >
                                                                <img
                                                                    src={
                                                                        item.photoData && item.photoData.length > 0
                                                                            ? item.photoData[0].url
                                                                            : "/assets/images/no-image.png"
                                                                    }
                                                                    alt=""
                                                                // className="w-auto max-w-unset"
                                                                />
                                                            </Link>
                                                        </div>

                                                        <div className="product-card__content p-sm-2" style={{ minWidth: "100%" }}>
                                                            <div className="flex-align gap-6 d-none">
                                                                <span className="text-xs fw-bold text-gray-600">4.8</span>
                                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                                    <i className="ph-fill ph-star" />
                                                                </span>
                                                                <span className="text-xs fw-bold text-gray-600">(17k)</span>
                                                            </div>

                                                            <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                                                <Link to="/product-details" className="link text-line-2">
                                                                    {item.name}
                                                                </Link>
                                                            </h6>
                                                            <div className="flex-align gap-4  d-none">
                                                                <span className="text-main-600 text-main-one-600 text-md d-flex">
                                                                    <i className="ph-fill ph-storefront" />
                                                                </span>
                                                                <span className="text-gray-500 text-xs">
                                                                    By Lucky Supermarket
                                                                </span>
                                                            </div>
                                                            <div className="product-card__content mt-14 d-flex justify-content-between align-items-center">
                                                                <div className="product-card__price mb-8 d-block">

                                                                    {
                                                                        (item.discountPrice !== 0 || item.discountPrice !== null || item.discountPrice !== "") && (
                                                                            <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                                                                                {"$"}
                                                                                {
                                                                                    item.discountPrice !== 0 || item.discountPrice !== null || item.discountPrice !== "" ? (
                                                                                        item.price
                                                                                    ) : (
                                                                                        item.discountPrice
                                                                                    )
                                                                                }
                                                                            </span>
                                                                        )
                                                                    }
                                                                    <span className="text-heading text-md fw-semibold  d-block">
                                                                        {"$"}
                                                                        {
                                                                            item.discountPrice !== 0 || item.discountPrice !== null || item.discountPrice !== "" ? (
                                                                                item.discountPrice
                                                                            ) : (
                                                                                item.price
                                                                            )
                                                                        }
                                                                        {" "}
                                                                        <span className="text-gray-500 fw-normal">/Qty</span>{" "}
                                                                    </span>


                                                                </div>

                                                                <Link
                                                                    to="/cart"
                                                                    className="product-card__cart btn  rounded-pill flex-align gap-8  justify-content-center d-none"
                                                                >
                                                                    <span>Add </span><i className="ph ph-shopping-cart" />
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            ))
                                        }
                                    </Slider>
                                )

                            } */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default RecommendedProducts;
